// src/components/common/Toast.jsx
import React, { useEffect } from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';

const ICONS = { 
  success: <CheckCircle size={18} />, 
  error: <XCircle size={18} />, 
  warning: <AlertTriangle size={18} />, 
  info: <Info size={18} /> 
};
const COLORS = {
  success: { bg: '#ecfdf3', border: '#a7f3d0', color: '#065f46' },
  error:   { bg: '#fef2f2', border: '#fecaca', color: '#991b1b' },
  warning: { bg: '#fffbeb', border: '#fde68a', color: '#78350f' },
  info:    { bg: '#f0f9ff', border: '#bae6fd', color: '#0c4a6e' },
};

const Toast = ({ message, type = 'info', onClose, duration = 3500 }) => {
  useEffect(() => {
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [onClose, duration]);

  const c = COLORS[type] || COLORS.info;
  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
      background: c.bg, border: `1px solid ${c.border}`, color: c.color,
      borderRadius: 10, padding: '12px 16px', boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
      display: 'flex', alignItems: 'center', gap: 10, minWidth: 260,
      fontSize: '0.875rem', fontWeight: 500, animation: 'slideUp 0.2s ease',
    }}>
      <span style={{ display: 'flex', alignItems: 'center' }}>{ICONS[type]}</span>
      <span style={{ flex: 1 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: c.color, display: 'flex', opacity: 0.6 }}>
        <X size={16} />
      </button>
    </div>
  );
};

// Simple Toast manager hook
export const useToast = () => {
  const [toast, setToast] = React.useState(null);
  const show = (message, type = 'info') => setToast({ message, type });
  const hide = () => setToast(null);
  const ToastComponent = toast ? <Toast {...toast} onClose={hide} /> : null;
  return { show, ToastComponent };
};

export default Toast;
